import { Component, OnInit, Input, EventEmitter, Output, ViewChild, TemplateRef } from '@angular/core';

import {MatDialog} from '@angular/material/dialog';

import { TypedefdialogComponent } from '../typedefdialog/typedefdialog.component';

import { KhandalguiComponent } from '../khandalgui/khandalgui.component';

import { VehiculeparamComponent } from '../vehiculeparam/vehiculeparam.component';

import { PredefparamchooseComponent } from '../predefparamchoose/predefparamchoose.component';

import { ConfigfraisparamsComponent } from '../configfraisparams/configfraisparams.component';

import { RecurrentComponent } from '../recurrent/recurrent.component';

import { ConfirmationDialogComponent } from '../confirmation-dialog/confirmation-dialog.component';

import { ServicepoolService } from '../services/servicepool.service';

import { MatOption } from '@angular/material/core'; 

import { MatSelect } from '@angular/material/select' ;

import {MatTableDataSource} from '@angular/material/table';
import {MatSort} from '@angular/material/sort';
import {MatPaginator} from '@angular/material/paginator';

import {DataSource} from '@angular/cdk/collections';
import {CdkTableModule} from '@angular/cdk/table';

@Component({
  selector: 'app-avenantblock',
  templateUrl: './avenantblock.component.html',
  styleUrls: ['./avenantblock.component.css']
})
export class AvenantblockComponent implements OnInit {

  Tabval = "" ;

  newParam = ""  ;

  theChoosenDataType = "" ;

  @Input() fraischarge : any ;

  garantie : any ;

  descriptionpack : any ;

  @Output() DeletionOrderToReturnBackEvent = new EventEmitter<string>();

  checkStatus = [] ;

  checkboxEditDeactivate = [] ;

  eltsType = [] ;


  choosenGarantieIndex : any ;

  saveBtnState = "done_all" ;

  primenameedit = "edit" ;

  baseElement = "" ;

  editprimename = 0 ;

  primeconfigObject : any ;

  retourClientWS : any ;

  choosenId : any ;

  valeur : any ;

  headClass = "card-header card-header-tabs card-header-primary" ;

  rowNumber = 0 ;
  resultArray = [] ;
  subTabLength = 2 ;

  descriptionfraischarge = "" ;


  allgarantie = [] ;
  params = [] ;
  paramsValues = [] ;
  paramsNames = [] ;
  askedParams = [] ;
  askedParamsValues = [] ;
  askedPredefCustParams = [] ;
  askedPredefCustParamsValues = [] ;
  allgarantiesForThisInsuranceType : any ;


  allGaranties = [] ;

  compositionFormComm = [] ;

  hereAreYourComplianceRules = [] ;


  dataSourceCompliance : DataSource<any> ;

  displayedColumnsCompliance: string[] = ['Facteur',  'Valeur'];

  rules = [] ;

  checkedParams : any ;
  
  @Input() configuration : any[] ;

  @Input() assurancetype : any ;

  @Input() compagnie : any ;

  @Input() categorie : any ;

  @Input() toutesVarFin : any ;


  configPrimeBtn = true ;

  samacaabiyoonwii :  any ;


  @ViewChild('spinnerDialog') spinnerDialog: TemplateRef<any>;
  spinnerDialogRef : any ;

  @ViewChild('fraischargeagedescript') fraischargedescriptDialog: TemplateRef<any>;
  fraischargedescriptDialogRef : any ;


  @ViewChild('matRef') matRef: MatSelect;

  clearGarantieSelect() {
    this.matRef.options.forEach((data: MatOption) => data.deselect());
  }

  constructor(public dialog: MatDialog,  private configServer: ServicepoolService) {
  }


  ngOnInit(): void {

    this.samacaabiyoonwii = sessionStorage.getItem("samacaabiyoonwii") ;
    let profil = sessionStorage.getItem("profil") ;

  	var onChunkArray = [] ;
  	var index = 0 ;
  	this.resultArray = this.fraischarge.composition.reduce((indexDead, item ) => { 
  	const chunkIndex = Math.floor(index/this.subTabLength)

  	if(!onChunkArray[chunkIndex]) {
  	  onChunkArray[chunkIndex] = [] ; // start a new chunk
  	}

  	onChunkArray[chunkIndex].push(item) ;

  	index++ ;

  	return onChunkArray ;
  	}, []) ;

    this.checkedParams =  this.fraischarge.composition;

    for (var i = 0; i< this.fraischarge.composition.length; i++) {
      this.checkStatus.push(true) ;
      this.eltsType.push([]) ;
    }

    this.descriptionfraischarge = this.fraischarge.description ;

    this.toutesVarFin ;

    this.getAllGarantiesForThisInsuranceTypeCompagnie(this.compagnie) ;

  }



  initialize(){
    this.checkStatus = [] ;
    this.checkboxEditDeactivate = [] ;
    this.checkedParams = [] ;

    var onChunkArray = [] ;
    var index = 0 ;
    this.resultArray = this.fraischarge.composition.reduce((indexDead, item ) => { 
    const chunkIndex = Math.floor(index/this.subTabLength)

    if(!onChunkArray[chunkIndex]) {
    onChunkArray[chunkIndex] = [] ; // start a new chunk
    }

    onChunkArray[chunkIndex].push(item) ;

    index++ ;

    return onChunkArray ;
    }, []) ;

    this.checkedParams =  this.fraischarge.composition;

    for (var i = 0; i< this.fraischarge.composition.length; i++) {
      this.checkStatus.push(true) ;
      this.eltsType.push([]) ;
    }

  }


  getAllPossibleGaranties(){
    console.log("Here we go 187 !!! ") ;
    /*this.configServer.getAllPossibleGaranties("thiswii", this.assurancetype.raniee).then( (retourbi) => {
      this.retourClientWS = retourbi ;
      var statutreq = this.retourClientWS.statutreq;
      console.log(this.retourClientWS.data) ;
      if(statutreq==1){
        console.log("Done") ;
        this.allGaranties = this.retourClientWS.data ; 
      }
      else{
        console.log("Failed") ;
      }
    }) ;*/    
  }



  choosedInSelectParamToAdd(slctd){

      if(slctd!=-3 && slctd!=-2 && slctd!=-1 && slctd!=-4 && slctd!=-5){
        this.fraischarge.composition.push( this.params[slctd].intitule ) ;
      }else{
        if(slctd==-5)
          this.fraischarge.composition.push( "Prime TTC" ) ;      
        if(slctd==-4)
          this.fraischarge.composition.push( "date De Traitement" ) ;      
        if(slctd==-3)
          this.fraischarge.composition.push( "Prime Nette" ) ;      
        if(slctd==-2)
          this.fraischarge.composition.push( "date Effet" ) ;      
        if(slctd==-1)
          this.fraischarge.composition.push( "date Echeance" ) ;      
      }

      this.checkStatus.push(true) ;

      var onChunkArray = [] ;

      var index = 0 ;

      this.resultArray = this.fraischarge.composition.reduce((indexDead, item ) => { 
      const chunkIndex = Math.floor(index/this.subTabLength) ;

      if(!onChunkArray[chunkIndex]) {
        onChunkArray[chunkIndex] = [] ; 
      }

      onChunkArray[chunkIndex].push(item) ;

      index++ ;

      return onChunkArray ;
      }, []) ; 

      this.clearGarantieSelect() ;
  }


  configPrime(){

    var choosenParams =[] ;

    choosenParams =  this.copyThisArray(this.fraischarge.composition) ;

    this.openDialogForPrimeConfig(this.fraischarge.nomvariable, 1, choosenParams, this.fraischarge.valeurformule) ;
  }

  configParamChangRules(){

    var choosenParams =[] ;

    choosenParams =  this.copyThisArray(this.fraischarge.composition) ;

    this.openDialogForPrimeConfig(this.fraischarge.nomvariable, 1, choosenParams, this.fraischarge.valeurformule) ;
  }


  getByKeyName(tab, name){
    for (var i = 0; i < tab.length; i++) {
      if(tab[i].name == name )
        return tab[i] ;
    }
     return {"valeur": "[]"} ;
  }


  savefraischarge(){
    this.updateVarAvenant() ;
  }


  getAllPossibleParamsForThisGarantie(){

    this.openSpinnerDialog();
    console.log("Here we go 187 !!! ") ;
    this.configServer.getAllPossibleParamsForThisGarantie("thiswii", this.garantie.intitule).then( (retourbi) => {    
    this.closeSpinnerDialog() ;
      this.retourClientWS = retourbi ;
      var statutreq = this.retourClientWS.statutreq;
      console.log(this.retourClientWS.data) ;
      if(statutreq==1){
        console.log("Done") ;
        //this.allBigCategories = this.retourClientWS.data ; 
      }
      else{
        console.log("Failed") ;
      }
    }) ;    
  }


  soppiMbirrMi(domaine){
	  this.Tabval = (this.Tabval==this.fraischarge.nomvariable)? "-":this.fraischarge.nomvariable ;
  }

  jsonElementFactory(baseElmt, newProp, intitule, type){
  	if (baseElmt=="")
  		return '{"primeName": "'+this.garantie.params.replace(/\s+/g, '').normalize('NFD').replace(/[\u0300-\u036f]/g, "")+'", "primeNameLibelle": "'+this.garantie.intitule+'", "params": [{'+'"name" : "'+newProp+'", "intitule": "'+intitule+'", "type": '+type+' }]}' ;  
  	else
  		return baseElmt.substring(0, baseElmt.length-2)+', {"name" : "'+newProp+'", "intitule": "'+intitule+'", "type": '+type+' }]}' ;
  }

  jsonElementFactoryFinale(baseElmt, formulation){

      return baseElmt.substring(0, baseElmt.length-1)+', "formulation" : '+formulation+'}' ;
  }




  getAllGarantiesForThisInsuranceTypeCompagnie(compagnieBi){

    this.allgarantie = [] ;
    this.params = [] ;
    this.paramsValues = [] ;
    this.paramsNames = [] ;
    this.askedParams = [] ;
    this.askedParamsValues = [] ;
    this.askedPredefCustParams = [] ;
    this.askedPredefCustParamsValues = [] ;

    this.configServer.getAllPossibleGarantiesCompagnie(this.samacaabiyoonwii, this.assurancetype.raniee, compagnieBi.name,  this.categorie.idcateg).then( (retourbi) => {
      this.retourClientWS = retourbi ;
      var statutreq = this.retourClientWS.statutreq;

      console.log("314 CALL " ,retourbi) ;

      if(statutreq==1){
        this.allgarantiesForThisInsuranceType = this.retourClientWS.data ;
        for (var i = 0 ; i <this.allgarantiesForThisInsuranceType.length; i++) {
          //if(this.allgarantiesForThisInsuranceType[i].mandatory==true){
            this.goOneForThis(i) ;
          //}
        }
      }
      else{
        console.log("Failed") ;
      }
    }) ;    
  }



  isalreadyIn(tabBi, data){
    for (var i = tabBi.length - 1; i >= 0; i--) {
      if (tabBi[i].nomFrmt==data.nomFrmt )
        return true;
    }
    return false ;
  }


  alReadyIn(benTableauObj, nomrecherche){
    for (var i = 0; i < benTableauObj.length; i++) {
          if(benTableauObj[i].nom==nomrecherche)
            return true ;
    }
    return false ;    
  }


  goOneForThis(ind){

    let potentialParams = JSON.parse(this.allgarantiesForThisInsuranceType[ind].params) ;

    for (var i = 0 ; i < potentialParams.length; i++) {
      if(potentialParams[i].type=="predefvehiv"){
          console.log("Has a PredefVehic ") ;

          if(!this.isalreadyIn(this.params, potentialParams[i]) ){
            this.params.push(potentialParams[i]) ;
          }                    

          if ( !this.paramsNames.includes(potentialParams[i].nomFrmt))
            this.paramsNames.push(potentialParams[i].nomFrmt) ;
      }
      if(potentialParams[i].type=="simple"){

        if(!this.isalreadyIn(this.params, potentialParams[i]) ){
          this.params.push(potentialParams[i]) ;
        }                    
        if ( !this.paramsNames.includes(potentialParams[i].nomFrmt)){
            this.paramsNames.push(potentialParams[i].nomFrmt) ;
            this.askedParams.push(potentialParams[i]) ;
            this.askedParamsValues.push("") ;
          }
      }
      if(potentialParams[i].type=="custompredef"){
        if(!this.isalreadyIn(this.params, potentialParams[i]) ){
          this.params.push(potentialParams[i]) ;
        }                    
        if ( !this.paramsNames.includes(potentialParams[i].nomFrmt)){
          this.paramsNames.push(potentialParams[i].nomFrmt) ;
          this.askedPredefCustParams.push(potentialParams[i]) ;
          this.askedPredefCustParamsValues.push("") ;
        }
      }
      if(potentialParams[i].type=="recurrent"){
          let allRemoteParams = this.configServer.getAllParamRecurrent(1, potentialParams[i].nomFrmt).then( (retourbi) => {
              this.retourClientWS = retourbi ;
              var statutrec = this.retourClientWS.statutreq ;

              if(statutrec==1){
                let data = this.retourClientWS.data ;  
                for (var i = 0 ; i <data.length; i++) {

                    if(!this.isalreadyIn(this.params, data[i]) ){
                      this.params.push(data[i]) ;
                    }                    

                    if(data[i].type=="predefvehiv"){
                      console.log("Inside") ;
                      if ( !this.paramsNames.includes(data[i].nomFrmt)){
                          this.paramsNames.push(data[i].nomFrmt) ;
                       }
                    }
                    if(data[i].type=="simple"){
                      if ( !this.paramsNames.includes(data[i].nomFrmt)){
                        this.paramsNames.push(data[i].nomFrmt) ;
                        this.askedParams.push(data[i]) ;
                        this.askedParamsValues.push("") ;
                      }
                    }
                    if(data[i].type=="custompredef"){
                      if ( !this.paramsNames.includes(data[i].nomFrmt)){
                        this.paramsNames.push(data[i].nomFrmt) ;
                        this.askedPredefCustParams.push(data[i]) ;
                        this.askedPredefCustParamsValues.push("") ;
                      }
                    }
                }

                  console.log("Params Names : ", this.paramsNames) ;
              }
              else
                console.log("Failed") ;
          }) ;    
      }
    }
    console.log("Params: ", this.params) ;
  }



  isSimpleWay(){
    return !(this.fraischarge.nomvariable.trim().localeCompare('Variables Impactées')==0) ;
  }



  onrulesChange(event){
    this.valeur = "" ;
    let choosenIndex = event.value ;    
    if(choosenIndex!=-1){
      this.choosenId = choosenIndex ;       
    }
  }




  openDialog(nomParam, typeIndex) {
    const dialogRef = this.dialog.open(TypedefdialogComponent, {
      data: {
        ParamsName: {"nomFrmt": this.formatThisString(nomParam), "intitule": nomParam, "type":"simple"} ,
        typechoice: ["***"]
      },
       disableClose: true
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log(result) ;
      this.eltsType[typeIndex] = result ;
    });
  }

  openDialogVehicParam() {
    const dialogRef1 = this.dialog.open(VehiculeparamComponent, {
      data: {
        ParamsName : [
            {"nomFrmt": this.formatThisString("Puissance"), "intitule": "Puissance", "type":"predefvehiv"},
            {"nomFrmt": this.formatThisString("Energie"), "intitule": "Energie", "type":"predefvehiv"},
            {"nomFrmt": this.formatThisString("Nombre de Place"), "intitule": "Nombre de Place", "type":"predefvehiv"},
            {"nomFrmt": this.formatThisString("Poids Total en Charge Autorisé (PTAC)"), "intitule": "Poids Total en Charge Autorisé (PTAC)", "type":"predefvehiv"},
            {"nomFrmt": this.formatThisString("Poids Vide"), "intitule": "Poids Vide", "type":"predefvehiv"},
            {"nomFrmt": this.formatThisString("Charge Utile"), "intitule": "Charge Utile", "type":"predefvehiv"},
            {"nomFrmt": this.formatThisString("Poids Total Roulant (PTR)"), "intitule": "Poids Total Roulant (PTR)", "type":"predefvehiv"},
            {"nomFrmt": this.formatThisString("Cylindre"), "intitule": "Cylindre", "type":"predefvehiv"},
            {"nomFrmt": this.formatThisString("Date mise en circulation"), "intitule": "Date mise en circulation", "type":"predefvehiv"},
            {"nomFrmt": this.formatThisString("Genre"), "intitule": "Genre", "type":"predefvehiv"},
            {"nomFrmt": this.formatThisString("Carosserie"), "intitule": "Carosserie", "type":"predefvehiv"},
            {"nomFrmt": this.formatThisString("Date Mise en Circulation"), "intitule": "Date Mise en Circulation", "type":"predefvehiv"}
        ]
      },

       disableClose: true
    });

    dialogRef1.afterClosed().subscribe(result => {
      console.log("Result For Vehicule Config") ;      
      var choosenVehicParams = JSON.parse(result) ;      

      for (var i = 0; i<choosenVehicParams.choosenParams.length; i++) {
        this.garantie.params.push(choosenVehicParams.choosenParams[i]) ;
        this.eltsType.push(choosenVehicParams.typos[i]) ;

        this.checkStatus.push(true) ;
        this.checkboxEditDeactivate.push(false) ;
        var onChunkArray = [] ;
        var index = 0 ;
        this.resultArray = this.garantie.params.reduce((indexDead, item ) => { 
          const chunkIndex = Math.floor(index/this.subTabLength) ;

          if(!onChunkArray[chunkIndex]) {
            onChunkArray[chunkIndex] = [] ; 
          }
          onChunkArray[chunkIndex].push(item) ;
          index++ ;
          return onChunkArray ;
        }, []) ; 
      }
    });
  }


  openDialogRecurrParam() {
    const dialogRef1 = this.dialog.open(RecurrentComponent, {
      data: {
        ParamsName : [
        ]
      },

       disableClose: true
    });

    dialogRef1.afterClosed().subscribe(result => {
      console.log("Result For Vehicule Config") ;      
      var choosenVehicParams = JSON.parse(result) ;      

      for (var i = 0; i<choosenVehicParams.choosenParams.length; i++) {
        this.garantie.params.push(choosenVehicParams.choosenParams[i]) ;
        this.eltsType.push(choosenVehicParams.typos[i]) ;

        this.checkStatus.push(true) ;
        this.checkboxEditDeactivate.push(false) ;
        var onChunkArray = [] ;
        var index = 0 ;
        this.resultArray = this.garantie.params.reduce((indexDead, item ) => { 
          const chunkIndex = Math.floor(index/this.subTabLength) ;

          if(!onChunkArray[chunkIndex]) {
            onChunkArray[chunkIndex] = [] ; 
          }
          onChunkArray[chunkIndex].push(item) ;
          index++ ;
          return onChunkArray ;
        }, []) ; 
      }
    });
  }



  openDialogPredefCustomParam() {
    const dialogRef1 = this.dialog.open(ConfigfraisparamsComponent, {
      data: {"assurtype":this.assurancetype, "compagnie": this.compagnie, "categorie": this.categorie},
       disableClose: true
    });

    dialogRef1.afterClosed().subscribe(result => {
      console.log("Result For Vehicule Config") ;      
      var outgoingParams = JSON.parse(result) ;      

      for (var i = 0; i<outgoingParams.choosenParams.length; i++) {
        this.fraischarge.composition.push( outgoingParams.choosenParams[i].intitule ) ;
      }

      this.checkStatus.push(true) ;

      var onChunkArray = [] ;

      var index = 0 ;

      this.resultArray = this.fraischarge.composition.reduce((indexDead, item ) => { 
      const chunkIndex = Math.floor(index/this.subTabLength) ;

      if(!onChunkArray[chunkIndex]) {
        onChunkArray[chunkIndex] = [] ; 
      }

      onChunkArray[chunkIndex].push(item) ;

      index++ ;

      return onChunkArray ;
      }, []) ; 

      this.clearGarantieSelect() ;

    });
  }


  onPrimeChoose(event, i, j) {
  	if (event.target.checked){
  		this.checkStatus[j+2*i]=true ;
      var typeIndex = j+2*i ;
  	}
  	else{
    		this.checkStatus[j+2*i]=false ;	  	
  	}
  	console.log(this.baseElement);	
  }


  ajouterParam(){

  	if (this.newParam != "" && this.theChoosenDataType!=""  && this.saveBtnState=="done_all"){
    	this.garantie.params.push( {"nomFrmt": this.formatThisString(this.newParam), "intitule": this.newParam, "type":"simple", "datatype": this.theChoosenDataType}) ;

  	  this.checkStatus.push(false) ;
  		this.checkboxEditDeactivate.push(false) ;

  		var onChunkArray = [] ;

  		var index = 0 ;

  		this.resultArray = this.garantie.params.reduce((indexDead, item ) => { 
  		const chunkIndex = Math.floor(index/this.subTabLength) ;

  		if(!onChunkArray[chunkIndex]) {
    		onChunkArray[chunkIndex] = [] ; 
  		}

  		onChunkArray[chunkIndex].push(item) ;

  		index++ ;

  		return onChunkArray ;
  		}, []) ; 

      this.theChoosenDataType = "" ;
  		this.newParam = "" ;
  	}
  }

  savePack(){

  	if (this.saveBtnState=="done_all"){
       this.openSpinnerDialog() ;

  		for (var i = 0; i< this.checkboxEditDeactivate.length; i++) {
  			this.checkboxEditDeactivate[i] = true ;
  		}
      var allParamsConfigs = [] ;
  		for (var i = 0; i< this.checkStatus.length; i++) {
  			if(this.checkStatus[i] == false){
  				this.fraischarge.composition.splice(i, 1 ) ;
			  }
		  }      

    this.configServer.updatePack("thiswii", this.fraischarge).then( (retourbi) => {

      this.closeSpinnerDialog()
      this.retourClientWS = retourbi ;
      var statutreq = this.retourClientWS.statutreq;
      if(statutreq==1){
        console.log("Done") ;
      }
      else{
        console.log("Failed") ;
      }
    }) ;    

      //this.initialize() ;

	  	//this.saveBtnState = "edit" ; 
      //this.configPrimeBtn = true ;

  	}else{

      this.headClass = "card-header card-header-tabs card-header-primary" ;
      this.saveBtnState = "done_all" ;
      this.configPrimeBtn = false ;  		
    }

  }



  updatefraischargeDescript(){
    this.fraischarge.description = this.descriptionfraischarge ;
    this.closefraischargeagedescriptDialog() ;
  }


  copyThisArray(arrayToCopy){
    var copyArray = [] ;
    for (var i = 0; i< arrayToCopy.length; i++) {
      let objBi =  {"nomFrmt": this.formatThisString(arrayToCopy[i]), "intitule": arrayToCopy[i], "type":"custompredefval"}   ;
      copyArray.push(objBi) ;
    }
    return copyArray ;
  }

  openDialogForPrimeConfig(nomPrime, typeIndex, params, laFormule) {

    var predefinedVariables = params ;

    let  dataLab =  {
        ParamsName: nomPrime,
        typechoice: predefinedVariables,
        formule: laFormule
      } ;


    console.log("dataLab ", dataLab ) ;



    const dialogRef = this.dialog.open(KhandalguiComponent, {
      data: {
        ParamsName: nomPrime,
        typechoice: predefinedVariables,
        formule: laFormule
      },
       disableClose: true
    });

    dialogRef.afterClosed().subscribe(result => {

      console.log("Post Closure") ;
      console.log(result) ;
      if(result!=undefined && result.includes("[") ){
        this.fraischarge.valeurformule = JSON.parse(result) ;
        console.log(this.fraischarge) ;
        this.headClass = "card-header card-header-tabs card-header-danger" ;
        this.updateVarAvenant() ;
      }
    });
  }



  updateVarAvenant(){     
      this.openSpinnerDialog() ;


      for (var i = 0; i< this.checkStatus.length; i++) {
        if(this.checkStatus[i] == false){
          this.fraischarge.composition.splice(i, 1) ;
        }
      }

      this.configServer.updateVarAvenant(this.samacaabiyoonwii, JSON.stringify(this.fraischarge) ).then( (retourbi) => {
          this.closeSpinnerDialog() ;
          this.retourClientWS = retourbi ;
          var statutrec = this.retourClientWS.statutreq ;
          if(statutrec==1){
            ;
          }
          else
            console.log("Failed") ;
      }) ; 

  }




  editPrime(){
    if(this.editprimename==0){
      this.editprimename = 1 ;
      this.primenameedit = "done";      
    }else{

      var toReturn = {"ordre":"rename", "garantie": this.garantie }; 

      this.DeletionOrderToReturnBackEvent.emit(JSON.stringify(toReturn)) ;
      this.editprimename = 0 ;
      this.primenameedit = "edit";            
    }
  }

  deletePrime(){

    var data = {"title": "Suppression Garantie", "message": "Voulez-vous vraiment supprimer cette Garantie ?"} ;
    const dialogRef1 = this.dialog.open(ConfirmationDialogComponent, {data});
    
    dialogRef1.afterClosed().subscribe(result => {
      console.log(result) ;
      if(result=="dlt"){
          var toReturn = {"ordre":"fermer", "garantie": this.garantie  }; 
          this.DeletionOrderToReturnBackEvent.emit(JSON.stringify(toReturn)) ;
      }
      else{
        console.log("") ;        
      }

    });
  }

  makeVisible(){
    this.fraischarge.usable = 1;
  }

  removeVisibility(){
    this.fraischarge.usable = 0;
  }

  formatThisString(name){
    return name.replace(/\s+/g, '').normalize('NFD').replace(/[\u0300-\u036f]/g, "") ;
  }


  openfraischargeagedescriptDialog() {
    this.fraischargedescriptDialogRef = this.dialog.open(this.fraischargedescriptDialog);
  }

  closefraischargeagedescriptDialog() {
    this.fraischargedescriptDialogRef.close();
  }


  openSpinnerDialog() {
    this.spinnerDialogRef = this.dialog.open(this.spinnerDialog);
  }

  closeSpinnerDialog() {
    this.spinnerDialogRef.close();
  }



}
